import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"

const IndexPage = () => (
  <Layout>
    <Seo title="toko online shop whatsapp" />
    <div className="col-12 col-md-12 p-3 p-md-5 text-center"
      style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}
      >
        <div className=" p-3 p-md-5">
    <StaticImage
      src="../images/was.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
    <h1 className="text-white">WHATSAPP SHOP</h1>
    <h3 className="text-white">Toko Online Shop Whatsapp order.</h3>
    <h3><a href="#Start" className="btn btn-light rounded-pill">Get Started Now</a></h3>
  
    </div>
    </div>
    <div className="col-12 col-md-12 p-3 p-md-5 text-center"
    id="Start"
      style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}
      >
        <div className="row">
          
    <div className="col-6 col-md-4 p-3 p-md-5 text-center">
      <div className="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
           <StaticImage
      src="../images/c.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
<h3>CMS</h3>
<p>Backoffice admin dashboard</p>
        <Link to="/cms" className="btn btn-dark rounded-pill">Lihat Display</Link>
      </div>
    </div>
    <div className="col-6 col-md-4 p-3 p-md-5 text-center">
    <div className="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
           <StaticImage
      src="../images/shop.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
<h3>Shop</h3>
        <p>Modern Online Shop App</p>
        <Link to="/shop" className="btn btn-dark rounded-pill">Intip Online Shop</Link>
      </div>
    </div>
    <div className="col-6 col-md-4 p-3 p-md-5 text-center">
    <div className="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
           <StaticImage
      src="../images/wo.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
      <h3>Whatsapp</h3>
        <p>Hanlding Order WA otomatis</p>
        <Link to="/whatsapp" className="btn btn-dark rounded-pill">Baca Lebih Lanjut</Link>
      </div>
    </div>
    <div className="col-6 col-md-4 p-3 p-md-5 text-center">
    <div className="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
           <StaticImage
      src="../images/qris.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
      <h3>QRIS</h3>
        <p>Dukungan QR Code Payment</p>
        <Link to="/qris" className="btn btn-dark rounded-pill">Detail QRIS Code</Link>
      </div>
    </div>
    <div className="col-6 col-md-4 p-3 p-md-5 text-center">
    <div className="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
           <StaticImage
      src="../images/webs.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
      <h3>Website</h3>
        <p>Mobile Website Include</p>
        
        <Link to="/website" className="btn btn-dark rounded-pill">Pelajari Website</Link>
      </div>
    </div>
    <div className="col-6 col-md-4 p-3 p-md-5 text-center">
    <div className="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
           <StaticImage
      src="../images/murah.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
      <h3>Murah</h3>
        <p>Layanan dengan harga murah</p>
        <Link to="/price" className="btn btn-dark rounded-pill">Pilih Layanan</Link>
      </div>
    </div>
    <div className="col-12 col-md-6 p-3 p-md-5 text-center">
    <div className="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
           <StaticImage
      src="../images/sh.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
      <h3>TOKO</h3>
        <p>Semakin sempurna untuk toko store outlet shop menggunakan layanan ini.</p>
        <Link to="/toko" className="btn btn-dark rounded-pill">Play Video Demo</Link>
      </div>
    </div>
    <div className="col-12 col-md-6 p-3 p-md-5 text-center">
    <div className="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
           <StaticImage
      src="../images/rm.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
      <h3>Resto</h3>
        <p>Manjakan pelanggan restoran cafe rumah makan mu dengan whatsapp shop order.</p>
        <Link to="/resto" className="btn btn-dark rounded-pill">Play Video Demo</Link>
      </div>
    </div>

    </div>
    </div>

    <div className="col-12 col-md-12 p-0 text-center"
      style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}
      >
    <StaticImage
      src="../images/3.jpg"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
    </div>

    <div className="col-12 col-md-12 p-3 p-md-5 text-center"
      style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}
      >
        <div class="p-3 p-md-5">
   <h3 class="text-white">Cara kerja Whatsapp Order.</h3>
    <div class="row">
      <div class="col-4 col-md-4 p-3">
      <StaticImage
      src="../images/v.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
      </div>
      <div className="col-8 col-md-8 p-3">
      <div className="card shadow rounded-pill bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
<p>Pelanggan Visit Mobile Web Via QR Code digital atau akses langsung ke website mu.</p>
        </div>
        </div>
        <div className="col-8 col-md-8 p-3">
      <div className="card shadow rounded-pill bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
<p>Setelah pelanggan memilih produk selanjutnya otomatis apps akan mengakumulasi total belanja nya, dan proses chek out akan masuk ke <a href="https://www.whatsapp.com/" rel="noreferrer" target="_blank">whatsapp</a> mu langsung.</p>
        </div>
        </div>
      <div class="col-4 col-md-4 p-3">
      <StaticImage
      src="../images/cek.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
      </div>
      <div className="col-4 col-md-4 p-3">
      <StaticImage
      src="../images/cs.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
      </div>
      <div className="col-8 col-md-8 p-3">
      <div className="card shadow rounded-pill bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
<p>Yei... dengan whastapp Shop kini semakin cepat dan mudah handling proses order pelanggan, order sekarang dan revolusi bisnis mu dengan layanan kami.</p>
        </div>
        </div>
    </div>
  
    </div>
    </div> 
    <div className="col-12 col-md-12 p-3 p-md-5 text-center text-white"
      style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}
      >
         <div className="text-white p-3 p-md-5">
         <StaticImage
      src="../images/logos.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
    />
<h3>Contact Us</h3>
<p>Whatsapp : +62895339403223 / Call Us : +62895339403223 / Email : axcora@gmail.com</p>
        </div>
        </div>
      </Layout>
)

export default IndexPage
